import { Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const ReviewsBar = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="reviews-rating-bar"
            className="bg-white border-b border-stone-200 py-2 sm:py-2.5 px-4"
        >
            <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 sm:gap-x-3.5 text-ink">
                <span
                    data-testid="reviews-rating-score"
                    className="text-base sm:text-xl font-bold leading-none"
                >
                    4,8/5
                </span>
                <div
                    data-testid="reviews-rating-stars"
                    className="relative flex items-center gap-0.5 sm:gap-1"
                    aria-label="4,8/5"
                >
                    <div className="flex items-center gap-0.5 sm:gap-1 opacity-25">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <Star
                                key={i}
                                className="h-3.5 w-3.5 sm:h-5 sm:w-5 text-[#e5b94e] fill-[#e5b94e]"
                                strokeWidth={0}
                            />
                        ))}
                    </div>
                    <div
                        className="absolute inset-y-0 left-0 flex items-center gap-0.5 sm:gap-1 overflow-hidden"
                        style={{ width: "96%" }}
                    >
                        {[0, 1, 2, 3, 4].map((i) => (
                            <Star
                                key={i}
                                className="h-3.5 w-3.5 sm:h-5 sm:w-5 text-[#e5b94e] fill-[#e5b94e] shrink-0"
                                strokeWidth={0}
                            />
                        ))}
                    </div>
                </div>
                <span
                    data-testid="reviews-rating-count"
                    className="text-[11px] sm:text-sm uppercase text-stone-500 tracking-[0.08em] sm:tracking-[0.2em] leading-none"
                >
                    {t("reviews.barCount")}
                </span>
            </div>
        </div>
    );
};
